// @flow
import * as React from 'react';
import {
    ArrowLeft,
    ArrowRight,
    ArrowWrapper,
    Content,
    Description,
    ItemWrapper,
    ModeName,
    PaginationContainer,
    StyledCSSTransition,
    Wrapper
} from './styles';
import { FormattedMessage } from 'react-intl';
import messages from './intl';
import ModeSelectorPagination from './pagination';
import TransitionGroup from 'react-transition-group/TransitionGroup';

const LEFT = 'left';
const RIGHT = 'right';

type SlideDirectionType = typeof LEFT | typeof RIGHT;

type Props = {
    modes: Array<{
        description?: string | React.Element<*>,
        key: string,
        name: string
    }>,
    onChange: (selectedIndex: number) => void,
    purpose: string,
    selectedIndex: number
};

type State = {
    slideDirection: SlideDirectionType
};

export default class ModeSelector extends React.Component<Props, State> {
    static defaultProps = {
        purpose: messages.purpose,
        selectedIndex: 0
    };

    state = {
        slideDirection: LEFT
    };

    onClickNext = (e: SyntheticEvent<*>) => {
        e.preventDefault();

        const nextIndex = this.props.selectedIndex + 1;
        const next = nextIndex < this.props.modes.length ? nextIndex : 0;
        this.updateState(LEFT, next);
    };

    onClickPrevious = (e: SyntheticEvent<*>) => {
        e.preventDefault();

        const previousIndex = this.props.selectedIndex - 1;
        const previous = previousIndex >= 0 ? previousIndex : this.props.modes.length - 1;
        this.updateState(RIGHT, previous);
    };

    updateState(slideDirection: SlideDirectionType, selectedIndex: number) {
        this.setState({
            slideDirection
        });
        this.props.onChange && this.props.onChange(selectedIndex);
    }

    render() {
        const { modes, purpose, selectedIndex } = this.props;
        const { slideDirection } = this.state;
        const selectedMode = modes[selectedIndex];
        const hasDescription = !!selectedMode.description;
        const hasMultipleModes = modes.length > 1;

        return (
            <Wrapper aria-label={purpose} role="region">
                {hasMultipleModes && (
                    <FormattedMessage {...messages.previousMode}>
                        {m => (
                            <ArrowWrapper aria-label={m} onClick={this.onClickPrevious} type="button">
                                <ArrowLeft />
                            </ArrowWrapper>
                        )}
                    </FormattedMessage>
                )}
                <Content aria-live="polite">
                    <TransitionGroup>
                        <StyledCSSTransition
                            classNames={`mode-selector-slide-${slideDirection}`}
                            key={selectedMode.name}
                            timeout={{ enter: 450, exit: 300 }}
                        >
                            <ItemWrapper>
                                <ModeName hasDescription={hasDescription}>{selectedMode.name}</ModeName>
                                {hasDescription && <Description>{selectedMode.description}</Description>}
                            </ItemWrapper>
                        </StyledCSSTransition>
                    </TransitionGroup>
                    {hasMultipleModes && (
                        <PaginationContainer>
                            <ModeSelectorPagination activePage={selectedIndex} pages={modes.length} />
                        </PaginationContainer>
                    )}
                </Content>
                {hasMultipleModes && (
                    <FormattedMessage {...messages.nextMode}>
                        {m => (
                            <ArrowWrapper aria-label={m} onClick={this.onClickNext} type="button">
                                <ArrowRight />
                            </ArrowWrapper>
                        )}
                    </FormattedMessage>
                )}
            </Wrapper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/mode-selector-slide/index.js